export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg width={s} height={s} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.83781 5.03998L5.04779 2.25L2.25781 5.03998"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04785 15.75V2.25"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1631 12.96L12.9531 15.75L15.7431 12.96"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9531 2.25V15.75"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
